<template>
    <div id="page-top" class="row ml-0 mr-0" style="min-height: 94%; position: absolute; left: 0; right: 0;">
        <div class="apply-admission">
            <div class="card bs-turq">
                <div class="apply-admission-inner">
                    <h2 class="title text-center mt-4">
                        <span>Reset your details</span>
                    </h2>
                    <div class="caption text-center">
                        <br />
                        We'll send you a link to get you sorted.
                    </div>
                    <div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:40px">
                            <div class="form-sent-main text-center">
                                <label>Email</label>
                                <input style="color: black; border: 1px solid black;" v-bind:class="{ 'not-valid': v_email }" v-model="email" type="text" placeholder="Please enter">
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1">

                            <div style="text-align: center; margin-top: 25px">
                                <button v-on:click="login" class="btn-cms-turq" href="#loader-modal" data-toggle="modal">SUBMIT</button>
                            </div>
                        </div>
                        <br />
                        <div v-if="v_summary" class="alert alert-danger" style="text-align: center;">
                            {{ v_summary }}
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 
<style scoped>
    ::placeholder{
        color: black;
    }

    .bs-turq {
        box-shadow: #42c1c4 0 0 20px 1px;
    }

    #page-top {
        background-color: #282D69;
        min-height: 856px;
    }

    .apply-admission {
        margin-top: 80px;
        left: 15%;
        position: relative;
        width: 70%;
        z-index: 100;
        margin-bottom: 20px;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'Forgot',
        components: {
        },
        data: function () {
            return {
                email: "",
                v_email: false,
                v_summary: ""
            }
        },
        methods: {
            validate: function () {
                this.v_email = false;
                this.v_summary = null;

                if (!this.isValidEmail(this.email)) {
                    this.v_summary = "Please enter a valid email address";
                    this.v_email = true;
                    return false;
                }

                return true;
            },
            async login() {
                var title = document.title;
                try {
                    if (this.validate()) {
                        await this.web('/auth/forgot', "Requesting reset link", {
                            email: this.email,
                            siteTitle: title
                        }, [400]);

                        this.$router.replace("/auth/forgotSuccess");
                    }
                }
                catch (e) {
                    if (e.response.status == 400) {
                        this.v_summary = e.response.data;
                    }
                }
            }
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
        }
    };
</script>
